export enum MessageState {
  Draft = 'draft',
  Sent = 'sent',
  Deleted = 'deleted',
}
